import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import SVG from "./solid/info-description.svg";
var InfoDescriptionSolid_default = forwardRef(
  (props, ref) => /* @__PURE__ */ jsx(SVG, { ref, ...props })
);
export {
  InfoDescriptionSolid_default as default
};
